<aside class="side-navigation" [attr.data-collapsed]="isCollapsed()">
    <nav
        class="side-navigation__nav"
        aria-label="Side"
        tabindex="-1"
        (keydown)="onNavigationKeydown($event)">

        @if (activeProfile() === 'domains') {
            <mon-domain-picker [isCollapsed]="isCollapsed()" />
        }

        @if (!isCollapsed()) {
            <ng-container
                [ngTemplateOutlet]="expandedItemList"
                [ngTemplateOutletContext]="{
                    $implicit: menuItems(),
                    level: 1,
                    listClass: 'side-navigation__list side-navigation__list--root'
                }">
            </ng-container>
        } @else {
            <ul class="side-navigation__list side-navigation__list--collapsed">
                @for (item of menuItems(); track item.id) {
                    <li class="side-navigation__list-item">
                        @if (hasChildren(item)) {
                            <button
                                type="button"
                                class="side-navigation__icon-button side-nav__action"
                                [class.side-navigation__icon-button--active]="activePath().has(item.id) || isCollapsedPopupOpen(item.id)"
                                [attr.id]="'side-nav-collapsed-trigger-' + item.id"
                                [attr.data-collapsed-trigger-id]="item.id"
                                [attr.data-item-id]="item.id"
                                [attr.data-level]="1"
                                [attr.aria-label]="item.label"
                                [attr.aria-expanded]="isCollapsedPopupOpen(item.id)"
                                [attr.aria-controls]="getCollapsedPopupPanelId(0, item.id)"
                                data-action-type="collapsed-disclosure"
                                [ngbTooltip]="item.label"
                                placement="right"
                                container="body"
                                triggers="mouseenter:mouseleave"
                                [disableTooltip]="isCollapsedPopupOpen(item.id)"
                                (click)="onCollapsedGroupToggle(item.id, $event)">
                                @if (resolveNavigationIcon(item.icon); as iconName) {
                                    <mon-svg-icon class="side-nav__icon" [name]="iconName" aria-hidden="true" />
                                }
                            </button>
                        } @else {
                            @if (isDialogItem(item)) {
                                <button
                                    type="button"
                                    class="side-navigation__icon-button side-nav__action"
                                    [class.side-navigation__icon-button--active]="activePath().has(item.id)"
                                    [attr.aria-label]="item.label"
                                    [attr.data-item-id]="item.id"
                                    [attr.data-level]="1"
                                    data-action-type="collapsed-dialog"
                                    [ngbTooltip]="item.label"
                                    placement="right"
                                    container="body"
                                    triggers="mouseenter:mouseleave"
                                    (click)="onDialogItemClick(item, $event)">
                                    @if (resolveNavigationIcon(item.icon); as iconName) {
                                        <mon-svg-icon class="side-nav__icon" [name]="iconName" aria-hidden="true" />
                                    }
                                </button>
                            } @else {
                                <a
                                class="side-navigation__icon-button side-nav__action"
                                [class.side-navigation__icon-button--active]="activePath().has(item.id)"
                                tabindex="0"
                                [uiSref]="resolveItemRoute(item)"
                                [uiParams]="resolveItemParams(item)"
                                [attr.aria-current]="activeId() === item.id ? 'page' : null"
                                [attr.aria-label]="item.label"
                                [attr.data-item-id]="item.id"
                                [attr.data-level]="1"
                                data-action-type="collapsed-link"
                                tabindex="0"
                                [ngbTooltip]="item.label"
                                placement="right"
                                container="body"
                                triggers="mouseenter:mouseleave"
                                (click)="onCollapsedLeafNavigate($event)"
                                (keydown.enter)="onCollapsedLeafNavigate($event)"
                                (keydown.space)="onCollapsedLeafNavigate($event)">
                                @if (resolveNavigationIcon(item.icon); as iconName) {
                                    <mon-svg-icon class="side-nav__icon" [name]="iconName" aria-hidden="true" />
                                }
                            </a>
                            }
                        }
                    </li>
                    @if (item.dividerAfter) {
                        <li class="side-navigation__divider-item" aria-hidden="true">
                            <div class="side-navigation__divider"></div>
                        </li>
                    }
                }
            </ul>
        }
    </nav>

    <div class="side-navigation__toggle-container">
        <button
            type="button"
            class="side-navigation__toggle-button"
            aria-label="Toggle side navigation view"
            [attr.aria-expanded]="!isCollapsed()"
            [ngbTooltip]="isCollapsed() ? 'Expand' : null"
            placement="right"
            container="body"
            (click)="toggleCollapsedState()">
            @if (!isCollapsed()) {
                <mon-svg-icon class="side-navigation__toggle-icon" name="leftPanelClose" aria-hidden="true" />
            } @else {
                <mon-svg-icon class="side-navigation__toggle-icon" name="leftPanelOpen" aria-hidden="true" />
            }
            @if (!isCollapsed()) {
                <span class="side-navigation__toggle-text">{{ collapseButtonText() }}</span>
            }
        </button>
    </div>
</aside>

@if (isCollapsed() && collapsedPopupLevels().length > 0) {
    @for (popupLevel of collapsedPopupLevels(); track popupLevel.panelId; let popupLevelIndex = $index) {
        <section
            class="side-navigation__collapsed-popup"
            tabindex="-1"
            [attr.id]="popupLevel.panelId"
            [attr.data-collapsed-popup-level]="popupLevelIndex"
            [attr.aria-labelledby]="popupLevel.labelledById"
            [style.top.px]="popupLevel.position.top"
            [style.left.px]="popupLevel.position.left"
            [style.max-height.px]="popupLevel.position.maxHeight"
            [style.z-index]="15 + popupLevelIndex"
            tabindex="-1"
            (keydown)="onNavigationKeydown($event)">
            <h3 class="side-navigation__collapsed-popup-title">{{ popupLevel.title }}</h3>

            <ul class="side-navigation__list side-navigation__list--collapsed-popup">
                @for (item of popupLevel.items; track item.id) {
                    <li class="side-navigation__list-item">
                        @if (hasChildren(item)) {
                            <button
                                type="button"
                                class="side-nav__action side-nav__action--disclosure"
                                [class.side-nav__action--expanded]="isCollapsedPopupDisclosureOpen(popupLevelIndex, item.id)"
                                [class.side-nav__action--active]="activeId() === item.id"
                                [class.side-nav__action--ancestor-active]="activePath().has(item.id) && activeId() !== item.id"
                                [attr.id]="getCollapsedPopupDisclosureId(popupLevelIndex, item.id)"
                                [attr.data-collapsed-popup-disclosure-id]="item.id"
                                [attr.data-popup-level]="popupLevelIndex"
                                [attr.data-item-id]="item.id"
                                [attr.data-level]="1"
                                [attr.aria-expanded]="isCollapsedPopupDisclosureOpen(popupLevelIndex, item.id)"
                                [attr.aria-controls]="getCollapsedPopupPanelId(popupLevelIndex + 1, item.id)"
                                data-action-type="collapsed-popup-disclosure"
                                (click)="onCollapsedPopupDisclosureToggle(popupLevelIndex, item.id)">
                                <span class="side-nav__action-content">
                                    <span class="side-nav__label" [title]="item.label">{{ item.label }}</span>
                                </span>
                                <i
                                    class="pi side-nav__chevron pi-chevron-right"
                                    aria-hidden="true">
                                </i>
                            </button>
                        } @else {
                            @if (isDialogItem(item)) {
                                <button
                                    type="button"
                                    class="side-nav__action side-nav__action--link"
                                    [class.side-nav__action--active]="activeId() === item.id"
                                    [class.side-nav__action--ancestor-active]="activePath().has(item.id) && activeId() !== item.id"
                                    [attr.data-item-id]="item.id"
                                    [attr.data-level]="1"
                                    data-action-type="collapsed-popup-link"
                                    (click)="onDialogItemClick(item)">
                                    <span class="side-nav__action-content">
                                        <span class="side-nav__label" [title]="item.label">{{ item.label }}</span>
                                    </span>
                                </button>
                            } @else {
                                <a
                                class="side-nav__action side-nav__action--link"
                                tabindex="0"
                                [uiSref]="resolveItemRoute(item)"
                                [uiParams]="resolveItemParams(item)"
                                [class.side-nav__action--active]="activeId() === item.id"
                                [class.side-nav__action--ancestor-active]="activePath().has(item.id) && activeId() !== item.id"
                                [attr.aria-current]="activeId() === item.id ? 'page' : null"
                                [attr.data-item-id]="item.id"
                                [attr.data-level]="1"
                                data-action-type="collapsed-popup-link"
                                (click)="onCollapsedLeafNavigate($event)"
                                (keydown.enter)="onCollapsedLeafNavigate($event)"
                                (keydown.space)="onCollapsedLeafNavigate($event)"
                                >
                                <span class="side-nav__action-content">
                                    <span class="side-nav__label" [title]="item.label">{{ item.label }}</span>
                                </span>
                            </a>
                            }
                        }
                    </li>
                }
            </ul>
        </section>
    }
}

<nav
    class="side-navigation__mobile-bar"
    aria-label="Mobile navigation"
    role="button"
    tabindex="0"
    [attr.aria-expanded]="!isCollapsed()"
    (click)="toggleCollapsedState()"
    (keydown.enter)="toggleCollapsedState()"
    (keydown.space)="toggleCollapsedState()">
    @for (item of menuItems(); track item.id) {
        @if (activePath().has(item.id)) {
            <div class="side-navigation__mobile-bar__header">
                <span class="side-navigation__mobile-bar__tab side-navigation__mobile-bar__tab--active" aria-current="page">
                    @if (resolveNavigationIcon(item.icon); as iconName) {
                        <mon-svg-icon class="side-nav__icon" [name]="iconName" aria-hidden="true" />
                    }
                    <span class="side-navigation__mobile-bar__tab-label">{{ item.label }}</span>
                </span>
            </div>
        }
    }
    <span class="side-navigation__mobile-bar__chevron" [ngClass]="isCollapsed() ? 'collapsed' : ''" aria-hidden="true">
        <i class="pi pi-chevron-up" aria-hidden="true"></i>
    </span>
</nav>

<div
    class="side-navigation__mobile-panel"
    [attr.aria-hidden]="isCollapsed() || null"
    [attr.inert]="isCollapsed() ? '' : null"
    aria-label="Navigation submenu">
    <ng-container
        [ngTemplateOutlet]="expandedItemList"
        [ngTemplateOutletContext]="{
            $implicit: menuItems(),
            level: 1,
            listClass: 'side-navigation__list side-navigation__list--root'
        }">
    </ng-container>
</div>

<ng-template
    #expandedItemList
    let-items
    let-level="level"
    let-listClass="listClass"
    let-listId="listId"
    let-listAriaLabel="listAriaLabel">
    <ul [class]="listClass" [attr.id]="listId" [attr.aria-label]="listAriaLabel">
        @for (item of items; track item.id) {
            <li class="side-navigation__list-item">
                @if (item.children && item.children.length > 0) {
                    <button
                        type="button"
                        class="side-nav__action side-nav__action--disclosure"
                        [class.side-nav__action--expanded]="expandedIds().has(item.id)"
                        [class.side-nav__action--active]="activeId() === item.id"
                        [class.side-nav__action--ancestor-active]="activePath().has(item.id) && activeId() !== item.id"
                        [attr.id]="'side-nav-disclosure-' + item.id"
                        [attr.data-disclosure-id]="item.id"
                        [attr.data-item-id]="item.id"
                        [attr.data-level]="level"
                        [style.padding-left.rem]="level === 1 ? 0.75 : (level * 0.75) + 0.75"
                        [attr.aria-expanded]="expandedIds().has(item.id)"
                        [attr.aria-controls]="'side-nav-panel-' + item.id"
                        data-action-type="disclosure"
                        (click)="onDisclosureToggle(item.id)">
                        <span class="side-nav__action-content">
                            @if (level === 1 && resolveNavigationIcon(item.icon); as iconName) {
                                <mon-svg-icon class="side-nav__icon" [name]="iconName" aria-hidden="true" />
                            }
                            <span class="side-nav__label" [title]="item.label">{{ item.label }}</span>
                        </span>
                        <i
                            class="pi side-nav__chevron"
                            [ngClass]="expandedIds().has(item.id) ? 'pi-chevron-up' : 'pi-chevron-down'"
                            aria-hidden="true">
                        </i>
                    </button>

                    @if (expandedIds().has(item.id)) {
                        <ng-container
                            [ngTemplateOutlet]="expandedItemList"
                            [ngTemplateOutletContext]="{
                                $implicit: item.children,
                                level: level + 1,
                                listClass: 'side-navigation__list side-navigation__list--child',
                                listId: 'side-nav-panel-' + item.id,
                                listAriaLabel: item.label + ' links'
                            }">
                        </ng-container>
                    }
                } @else {
                    @if (isDialogItem(item)) {
                        <button
                            type="button"
                            class="side-nav__action side-nav__action--link"
                            [class.side-nav__action--active]="activeId() === item.id"
                            [class.side-nav__action--ancestor-active]="activePath().has(item.id) && activeId() !== item.id"
                            [attr.data-item-id]="item.id"
                            [attr.data-level]="level"
                            [style.padding-left.rem]="level === 1 ? 0.75 : (level * 0.75) + 0.75"
                            data-action-type="dialog"
                            (click)="onDialogItemClick(item)">
                            <span class="side-nav__action-content">
                                @if (level === 1 && resolveNavigationIcon(item.icon); as iconName) {
                                    <mon-svg-icon class="side-nav__icon" [name]="iconName" aria-hidden="true" />
                                }
                                <span class="side-nav__label" [title]="item.label">{{ item.label }}</span>
                            </span>
                        </button>
                    } @else {
                        <a
                        class="side-nav__action side-nav__action--link"
                        [uiSref]="resolveItemRoute(item)"
                        [uiParams]="resolveItemParams(item)"
                        [class.side-nav__action--active]="activeId() === item.id"
                        [class.side-nav__action--ancestor-active]="activePath().has(item.id) && activeId() !== item.id"
                        [attr.aria-current]="activeId() === item.id ? 'page' : null"
                        [attr.data-item-id]="item.id"
                        [attr.data-level]="level"
                        [style.padding-left.rem]="level === 1 ? 0.75 : (level * 0.75) + 0.75"
                        data-action-type="link"
                        >
                        <span class="side-nav__action-content">
                            @if (level === 1 && resolveNavigationIcon(item.icon); as iconName) {
                                <mon-svg-icon class="side-nav__icon" [name]="iconName" aria-hidden="true" />
                            }
                            <span class="side-nav__label" [title]="item.label">{{ item.label }}</span>
                        </span>
                    </a>
                    }
                }
            </li>

            @if (level === 1 && item.dividerAfter) {
                <li class="side-navigation__divider-item" aria-hidden="true">
                    <div class="side-navigation__divider"></div>
                </li>
            }
        }
    </ul>
</ng-template>
